<template>
  <div class="right">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'app-settings-options'
}
</script>

